module.exports = __webpack_public_path__ + "static/media/reports_002.c2f4d9a6.svg";